import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-tw';
import { Dropdown } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { LanguageList } from '@util/i18n';
import { LanguageType } from '@share/enums';
import { css } from '@emotion/react';
import { user } from '@state/user';

function LanguageSwitcher(): JSX.Element {
  /* Define state / hook */
  const { language, setLanguage } = user.useContainer();

  /* Custom Data Object for render or other usages */
  const handleSelect = (lang: string | null) => {
    if (lang) setLanguage(lang as LanguageType);
  };

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Styling */

  /* Render */
  return (
    <div className="menu_card mb-5">
      {/* For HTML lang attributes */}
      <Helmet htmlAttributes={{ lang: language }} />
      <Dropdown onSelect={handleSelect}>
        <Dropdown.Toggle
          css={css`
            padding: 0.8rem 3rem;
            font-size: 1.5rem;
            background-color: var(--primary-color);
            border-color: var(--primary-color);
            border-radius: 5px;
            color: var(--primary-color2);
          `}
          id="dropdown-basic"
          variant="secondary"
        >
          {LanguageList.find((item) => item.key === language)?.name ||
            LanguageList[0].name}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {LanguageList.map((item) => (
            <Dropdown.Item key={item.key} eventKey={item.key} href="#">
              {item.name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default LanguageSwitcher;
